import axios from 'axios';
import authService from './authService';

const http = axios.create({
    baseURL: `${authService.getCaseManagerBasePath()}/api`
});

const captchaService = {    
    getCaptcha:
        () => {
            return authService.getToken()
                .then((authResponse) => {
                    return http.get(`${authService.getCaseManagerBasePath()}/api/captcha`, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${authResponse.data.access_token}`
                        }
                    });
                });
        },
    validateCaptcha:
        (value, token) => {
            return authService.getToken()
                .then((authResponse) => {
                    return http.post(`${authService.getCaseManagerBasePath()}/api/captcha/validate`, {
                        token,
                        value
                    }, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${authResponse.data.access_token}`
                        }
                    });
                });
        }

};

export default captchaService;
